import React, { useState } from "react";
import { Form, Dropdown } from "antd";
import { ApartmentOutlined, EditOutlined } from "@ant-design/icons";
import { useMutation } from "react-query";
import moment from "moment";
import { AxiosAreasAPI } from "../Api";
import ActionsModal from "../../common/components/ActionsModal";
import AreaEditForm from "./AreaEditForm";
import ParentAreaEditForm from "./ParentAreaEditForm";
import ParentAreaModalInfo from "./ParentAreaModalInfo";
import {
  onError,
  onSuccess,
} from "../../common/components/AreasPositions/RequestSolvers";

const AreaEditionAction = ({ area, reload }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isParentEditModalOpen, setIsParentEditModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [parentForm] = Form.useForm();

  const { mutate: areaMutation } = useMutation(
    ["editArea"],
    AxiosAreasAPI.editArea,
    {
      onError: (error) =>
        onError(
          error,
          ["code", "end_date"],
          "Não foi possível realizar a solicitação de edição da área!",
        ),
      onSuccess: () =>
        onSuccess(
          reload,
          form,
          () => setIsEditModalOpen(false),
          "Área editada com sucesso!",
        ),
    },
  );

  const { mutate: parentMutation } = useMutation(
    ["editParent"],
    AxiosAreasAPI.editParentArea,
    {
      onError: (error) =>
        onError(
          error,
          ["parent_area", "end_date"],
          "Não foi possível realizar a solicitação de alteração da área pai!",
        ),
      onSuccess: () =>
        onSuccess(
          reload,
          parentForm,
          () => setIsParentEditModalOpen(false),
          "Área pai alterada com sucesso!",
        ),
    },
  );

  const editArea = (values) => {
    areaMutation({
      ...values,
      start_date: moment(values.start_date).format("YYYY-MM-DD"),
      end_date: values.end_date
        ? moment(values.end_date).format("YYYY-MM-DD")
        : undefined,
      id: area.id,
    });
  };

  const editParentArea = (values) => {
    parentMutation({
      ...values,
      start_date: moment(values.start_date).format("YYYY-MM-DD"),
      end_date: moment(values.end_date).format("YYYY-MM-DD"),
      id: area.id,
    });
  };

  const items = [
    {
      key: "editArea",
      label: (
        <div onClick={() => setIsEditModalOpen(true)}>
          <EditOutlined style={{ marginRight: "8px" }} />
          Editar área
        </div>
      ),
    },
    {
      key: "editParentArea",
      label: (
        <div onClick={() => setIsParentEditModalOpen(true)}>
          <ApartmentOutlined style={{ marginRight: "8px" }} />
          Alterar área pai
        </div>
      ),
    },
  ];

  return (
    <>
      <Dropdown menu={{ items }} trigger={["click"]}>
        <EditOutlined />
      </Dropdown>

      <ActionsModal
        isModalOpen={isEditModalOpen}
        setIsModalOpen={setIsEditModalOpen}
        onSubmit={editArea}
        form={form}
        button={null}
        context={`Editar ${area.name}`}
      >
        <AreaEditForm form={form} area={area} />
      </ActionsModal>

      <ActionsModal
        isModalOpen={isParentEditModalOpen}
        setIsModalOpen={setIsParentEditModalOpen}
        onSubmit={editParentArea}
        form={parentForm}
        button={null}
        context={`Alterar área pai de ${area.name}`}
      >
        <>
          <ParentAreaEditForm form={parentForm} area={area} />
          <ParentAreaModalInfo form={parentForm} area={area} />
        </>
      </ActionsModal>
    </>
  );
};

export default AreaEditionAction;
